import { DividerAlignContent as FluentDividerAlignContent, DividerAppearance as FluentDividerAppearance, DividerOrientation as FluentDividerOrientation, DividerRole as FluentDividerRole } from "@fluentui/web-components";
/**
 * Align-content values supported by {@link Divider}.
 * @public
 */
export const DividerAlignContents = {
    ...FluentDividerAlignContent
};
/**
 * Appearance values supported by {@link Divider}.
 * @public
 */
export const DividerAppearances = {
    ...FluentDividerAppearance
};
/**
 * Orientation values supported by {@link Divider}.
 * @public
 */
export const DividerOrientations = {
    ...FluentDividerOrientation
};
/**
 * Role values supported by {@link Divider}.
 * @public
 */
export const DividerRoles = {
    ...FluentDividerRole
};
//# sourceMappingURL=divider.options.js.map